<template>
    <!-- The description goes through the `text` prop, not the default slot: a
         `<template v-if>` still leaves `$slots.default` defined, so KTeaserCard
         would render an empty `__text` div (and its body gap) whenever the
         package has no description. -->
    <KTeaserCard :text="regions.text ? packageData.content.description : undefined">
        <template
            v-if="displayImage?.filename"
            #media
        >
            <NuxtLink
                :to="packageUrl"
                @click="select('image')"
            >
                <NuxtImg
                    :src="displayImage.filename"
                    :alt="displayImage.alt || packageData.name"
                    width="712"
                    height="400"
                    fit="cover"
                    format="auto"
                    loading="lazy"
                    sizes="xs:100vw sm:100vw md:433px lg:400px"
                />
            </NuxtLink>
        </template>

        <template
            v-if="displayImage?.filename && categoryLabel"
            #eyebrow
        >
            {{ categoryLabel }}
        </template>

        <template
            v-if="packageData.content.duration"
            #meta
        >
            <span>
                <Icon
                    name="tabler:clock"
                    aria-hidden="true"
                />
                {{ packageData.content.duration }}
            </span>
        </template>

        <template #title>
            <NuxtLink
                :to="packageUrl"
                @click="select('title')"
            >
                {{ packageData.name }}
            </NuxtLink>
        </template>

        <template
            v-if="regions.inclusions && included.length"
            #content
        >
            <KChecklist
                :items="included"
                label="What is included:"
                size="sm"
            >
                <NuxtLink
                    v-if="packageData.content.included_more"
                    :to="packageUrl"
                    @click="select('inclusions')"
                >
                    + View {{ packageData.content.included_more }} more inclusions &amp; details
                </NuxtLink>
            </KChecklist>
        </template>

        <template
            v-if="regions.price && packageData.content.from_price != null"
            #price
        >
            <span>{{ priceBasisLabel }}</span>
            <span>from ${{ packageData.content.from_price }}</span>
        </template>

        <template
            v-if="regions.action"
            #action
        >
            <KButton
                :as="nuxtLink"
                :to="packageUrl"
                size="sm"
                @click="select('details')"
            >
                Check details
            </KButton>
        </template>
    </KTeaserCard>
</template>

<script setup>
import { KButton, KChecklist, KTeaserCard } from '@vemedia/karibu'
import { computed, resolveComponent } from 'vue'
import { PACKAGE_CATEGORIES } from '#shared/package-categories'
import resolveDetailLevel from '~/helpers/cardDetailLevels'

const props = defineProps({
    packageData: {
        type: Object,
        required: true,
    },
    detail: {
        type: String,
        default: 'full',
    },
})

const emit = defineEmits(['select'])

const nuxtLink = resolveComponent('NuxtLink')
const regions = computed(() => resolveDetailLevel(props.detail))
const packageUrl = computed(() => `/${props.packageData.full_slug}`)
const displayImage = computed(() => props.packageData.content.image)
const included = computed(() => props.packageData.content.included || [])
const categoryLabel = computed(() => PACKAGE_CATEGORIES[props.packageData.content.category] || '')
const priceBasisLabel = computed(() => props.packageData.content.price_basis === 'per_couple'
    ? 'Price per couple'
    : 'Price per traveler')

function select(action) {
    emit('select', action)
}
</script>
